
export const userKey = 'userInfo'
export const baseApiUrl = process.env.VUE_APP_URL
export const avatarPhoto = 'av'
import axios from "axios"
export async function renewLocalStorage(newToken) {

    try {
        await axios.post(`${baseApiUrl}/validateToken`, { token: newToken });
    } catch (e) {
        console.log(e)
    }
}

